<template>
<div>
    <v-container fluid class="hero-loader">
        <v-skeleton-loader  class="mx-auto" type="image"/>
        <v-skeleton-loader  class="mx-auto" type="image"/>
        <v-skeleton-loader  class="mx-auto" type="image"/>
    </v-container>
    <v-container fluid>
        <v-row>
        <v-col cols="4">
            <v-skeleton-loader type="card" />
        </v-col>
            <v-col cols="4">
            <v-skeleton-loader type="card" />
        </v-col>
        <v-col cols="4">
            <v-skeleton-loader type="card" />
        </v-col>
        </v-row>
        <v-row>
        <v-col cols="4">
            <v-skeleton-loader type="card" />
        </v-col>
            <v-col cols="4">
            <v-skeleton-loader type="card" />
        </v-col>
        <v-col cols="4">
            <v-skeleton-loader type="card" />
        </v-col>
        </v-row>
        <v-row>
        <v-col cols="4">
            <v-skeleton-loader type="card" />
        </v-col>
            <v-col cols="4">
            <v-skeleton-loader type="card" />
        </v-col>
        <v-col cols="4">
            <v-skeleton-loader type="card" />
        </v-col>
        </v-row>
    </v-container>
</div>
</template>

<script>
export default {
  name: 'SkeletonLoaderModule',
};
</script>

<style lang="scss" scoped>
.image-up-loader {
    height: 800px !important;
}

</style>
